import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

      if (!sessionId) {
        toast.error("No session found. Please try again.");
        navigate("/login", { replace: true });
        return;
      }

      try {
        const res = await authApi.googleCallback(sessionId);
        localStorage.setItem("auth_token", res.data.token);
        localStorage.setItem("auth_user", JSON.stringify(res.data.user));

        const role = res.data.user.role;
        if (role === "admin") {
          toast.success("Welcome back, Admin!");
          window.location.href = "/admin";
        } else if (role === "user") {
          toast.success(`Welcome, ${res.data.user.name || res.data.user.username}!`);
          window.location.href = "/user";
        } else if (role === "product") {
          toast.success("Welcome to SilverLine — Product view");
          window.location.href = "/product";
        } else {
          toast.success(`Welcome, ${res.data.user.partner_name || res.data.user.username}!`);
          window.location.href = "/partner";
        }
      } catch (err) {
        const detail = err.response?.data?.detail || "Google sign-in failed";
        toast.error(detail);
        navigate("/login", { replace: true });
      }
    };

    processCallback();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-slate-50" data-testid="auth-callback">
      <div className="text-center space-y-3">
        <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-sm text-slate-500">Signing you in with Google...</p>
      </div>
    </div>
  );
}
